module.exports = __webpack_public_path__ + "img/baidu.67c73f37.png";